import { IsArray } from "@pdfking/tfunc"

import { to_array } from "./to_array"

/**
 * Sorts iterable by comparison function.
 *
 * Creates new sorted array (does not modify original).
 * Comparison function returns boolean (true if a > b).
 *
 * @param iterable - Array, object, or primitive to sort
 * @param f - Comparison function (a, b) => boolean (default: a > b)
 * @returns Sorted array
 *
 * @example
 * ```ts
 * import { sort } from "@pdfking/rfunc"
 *
 * sort([3, 1, 2]) // [1, 2, 3]
 * sort([3, 1, 2], (a, b) => a < b) // [3, 2, 1]
 * ```
 */
export const sort = (iterable, f = (a, b) => a > b) => {
  // javascript sort wants you to return 1 or -1.
  // we really want a boolean check, which is why we first cast the test to bool and then we cast to an integer such us 1 / -1

  // @ts-expect-error - boolean arithmetic intentional
  const t = (a, b) => (f(a, b) == true) * 2 - 1

  if (IsArray(iterable)) {
    //javascript sort is done in place.
    // to_array is not doing a copy if the object is already an array
    // we need to fix this case by creating a copy and sort after
    return [].concat(iterable).sort(t)
  }
  return to_array(iterable).sort(t)
}
